import axios from '../utils/axios';

export default function fetchLeadsMap(recId,params) {
    return (
        axios.get('/recruiter/'+ recId+'/getLeadsMap',{
            params:params
        })
        .then(res => {
            return res.data.data
        })
        .catch(err => {
            return err;
        })
    )
}
